import LocationAdapter from 'shared/location_adapter';
import RedirectHelper from 'commons/Utils/RedirectHelper';
import TransparentHeaderAtTop from 'desktop/components/transparent_header_at_top';
import KidsMode from 'commons/KidsMode/KidsMode';

export default class KidsHeader extends TransparentHeaderAtTop {
  constructor({ element: $element }){
    super({element: $element})
    this.locationAdapter = new LocationAdapter();
  }

  init() {
    if(KidsMode.isActive()) {
      if(RedirectHelper.shouldRedirectToKids(this.locationAdapter.pathname)) {
        LocationAdapter.href("/kids");
      }
      KidsMode.activate();
    } else {
      return;
    }

    if (this.hasPremiumHeadline()) {
      this.bindScroll();
      this.addTransparentHeader();
      this.addClassToArticleContainer('has-premium-headline');
    }

    this.bindClickButton();
  }

  bindClickButton() {
    this.element.querySelector(".kids-header__switch").addEventListener('click', () => KidsMode.deactivate())
  }

  showElement() {
    this.element.style.display = "flex";
  }

  useTransparentLogo() {
    return;
  }
}
